/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Translation_Aria_LabelInputs */

const en_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Translation Event ${i?.eventIndex}`)
};

const fr_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement de traduction ${i?.eventIndex}`)
};

const de_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übersetzungsereignis ${i?.eventIndex}`)
};

const it_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento di traduzione ${i?.eventIndex}`)
};

const ru_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие перевода ${i?.eventIndex}`)
};

const es_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento de traducción ${i?.eventIndex}`)
};

const zh_cn2_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`翻译事件${i?.eventIndex}`)
};

const ja_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`翻訳イベント ${i?.eventIndex}`)
};

const hi_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुवाद घटना ${i?.eventIndex}`)
};

const pt_pt2_event_translation_aria_label = /** @type {(inputs: Event_Translation_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento de tradução ${i?.eventIndex}`)
};

/**
* | output |
* | --- |
* | "Translation Event {eventIndex}" |
*
* @param {Event_Translation_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_translation_aria_label = /** @type {((inputs: Event_Translation_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Translation_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_translation_aria_label(inputs)
	if (locale === "de") return de_event_translation_aria_label(inputs)
	if (locale === "it") return it_event_translation_aria_label(inputs)
	if (locale === "ru") return ru_event_translation_aria_label(inputs)
	if (locale === "es") return es_event_translation_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_translation_aria_label(inputs)
	if (locale === "ja") return ja_event_translation_aria_label(inputs)
	if (locale === "hi") return hi_event_translation_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_translation_aria_label(inputs)
	return en_event_translation_aria_label(inputs)
});